import { css, type TwStyle } from "twin.macro";
import { type RuleSet } from "styled-components";

export function hover(hoverId?: string, styles?: TwStyle | RuleSet<object>) {
  return css`
    &:hover,
    ${`#${hoverId}`}:hover & {
      ${styles}
    }
  `;
}

export function round(num: number, decimals = 2) {
  return parseFloat(num.toFixed(decimals));
}

export function composeValueWithUnit(value?: number | string, defaultValue = "0", unit = "px") {
  if (value === 0) {
    return "0";
  }

  if (value) {
    return `${value}${unit}`;
  }

  return defaultValue === "0" ? "0" : `${defaultValue}${unit}`;
}
